const getFiscalEntitiesFromInterval = (
  interval: FiscalInterval,
  fiscalRanges: FixedPeriods.AllFiscals | undefined,
):
  | FixedPeriods.FiscalPeriod[]
  | FixedPeriods.FiscalQuarter[]
  | FixedPeriods.FiscalYear[]
  | undefined => {
  if (!fiscalRanges) {
    return;
  }
  if (interval === 'fiscalYear') {
    return fiscalRanges.fiscalYears;
  } else if (interval === 'fiscalQuarter') {
    return fiscalRanges.fiscalQuarters;
  } else if (interval === 'fiscalPeriod') {
    return fiscalRanges.fiscalPeriods;
  } else {
    const e = new Error();
    e.name = `Unknown fiscal interval: ${interval}`;
    throw e;
  }
};
export default getFiscalEntitiesFromInterval;
